<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCard>
            <CCardHeader>
              <CRow>
                <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                  <strong>{{$t('requestProduct')}}</strong>

                </CCol>
                <CCol col="4" style="text-align: end">

                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="secondary"
                      @click="insert_data_factor()"
                  >{{ $t("buttons.submit") }}
                  </CButton>
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="secondary"
                  >{{ $t("buttons.print") }}
                  </CButton>

                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>

              <CRow>
                <CCol  col="3">

                  <CSelect
                          :value.sync="selected_priority"
:label="$t('tables.type')"
                          horizontal
                          :options="priority_items"
                  />
                </CCol>
                <CCol  col="3">
                  <div>
                    <date-picker
                        v-model="date"

                        :label="$t('components.supplyTime')"
                    ></date-picker>
                  </div>
                </CCol>
                <CCol  col="3">
                  <CSelect
                      :placeholder="$t('RequestType')"

                      :value.sync="selectedType"
                      :options="selectTypes"
                  />
                </CCol>

                <CCol col="3">
                  <CSelect
                          :options="department_items"
                          :value.sync="selected_department"

                          :placeholder="$t('selectDepartmanUnit')"

                  />
                </CCol>

              </CRow>

            </CCardBody>

<!--            <CCardHeader>-->
<!--              <strong>{{ $t('components.documentProducts') }} {{document_person_method_name}}</strong>-->
<!--            </CCardHeader>-->
            <CCardBody>

              <CRow>
                <CCol col="3" style="align-self: flex-end;margin-bottom: 1rem">

                  <label v-if="status_product_form!=-1">{{ product_name }}</label>
                  <label v-else > {{ $t('components.searchProduct') }} </label>
                  <treeselect
                      v-model="selected_product"
                      v-if="status_product_form==-1"
                      ref="product_searcher"
                      id="product_seeker"
                      :async="true"
                      @select="select_product"

                      :load-options="load_products"
                      :placeholder="$t('components.searchProduct')"
                      :normalizer="normalizer_products"
                  />
                </CCol>

<!--                <CCol col="2">-->

<!--                  <CSelect-->
<!--                      :options="data_units"-->
<!--                      :label="$t('components.productUnit')"-->
<!--                      :value.sync="product_unit"-->
<!--                  />-->
<!--                </CCol>-->
                <CCol col="2">

                  <CInput
                      :label="$t('components.productQty')"
                      type="number"
                      v-on:keypress="isNumber($event)"

                      v-model="product_count"
                  />
                </CCol>
<!--                <CCol col="2">-->
<!--                  <label  > تامین کننده </label>-->

<!--                  <treeselect-->
<!--                      v-if="status_form==0"-->
<!--                      v-model="document_person"-->
<!--                      :async="true"-->
<!--                      @select="select_supplier"-->


<!--                      :load-options="load_persons"-->
<!--                      :placeholder="selectedTypeLabel"-->
<!--                      :normalizer="normalizer_persons"-->
<!--                  />-->
<!--                </CCol>-->
                <CCol col="2"  v-if="1==0">
                  <CInput
                      :label="$t('components.existence')"
                      type="number"
                      v-on:keypress="isNumber($event)"
                      disabled="true"
                      v-model="product_existance"
                  />
                </CCol>

                <CCol col="3">
                  <CInput
                      :label="$t('tables.summary')"
                      v-model="product_summary"
                  />
                </CCol>



                <CCol col="1" style="align-self: flex-end;margin-bottom: 1rem">
                  <CButton style="alignment-baseline: bottom" v-if="status_product_form==-1"
                           @click="add_product_to_document()" size="sm"
                           color="primary">
                    <CIcon name="cil-plus"/>
                    <!--                                        {{$t('buttons.addProduct')}}-->
                  </CButton>

                  <CButton v-if="status_product_form!=-1" @click="update_product_to_document()"
                           size="sm"
                           color="primary">
                    <CIcon name="cil-plus"/>
                    <!--                                      {{$t('buttons.editProduct')}}-->
                  </CButton>

                </CCol>

              </CRow>

              <CDataTable
                  :items="product_items"
                  :fields="product_fields"

                  :items-per-page="200"
                  hover
                  sorter

              pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">
                    <p >{{ item.row_id + 1 }}</p>

                  </td>

                </template>
                <template #name="{item}">

                  <td>
                    <p >{{ item.name }}</p>

                  </td>

                </template>

                <template #unit="{item}">

                  <td>
                    <p >{{ item.unit_value_name }}</p>

                  </td>

                </template>

                <template #qty="{item}">

                  <td>
                    <p >{{ item.count }}</p>

                  </td>

                </template>
                <template #price="{item}">

                  <td>
                    <p >
                      {{ get_currency(item.price) }}</p>

                  </td>

                </template>
                <template #totalPrice="{item}">

                  <td>
                    <p >
                      {{
                        get_currency(calculate_total_price(item))
                      }} </p>

                  </td>

                </template>
                <template #offPrice="{item}">
                  <td>
                    <p >
                      {{
                        get_currency(calculate_off_price(item))
                      }} </p>
                  </td>

                </template>
                <template #taxPrice="{item}">
                  <td>
                    <p >
                      {{
                        get_currency(calculate_tax_price(item))
                      }} </p>
                  </td>

                </template>
                <template #totalPayPrice="{item}">
                  <td>
                    <p >
                      {{
                        get_currency(calculate_total_pay_price(item))
                      }} </p>
                  </td>

                </template>
                <template #weight="{item}">

                  <td>
                    <p >
                      {{
                        (item.weight * item.count * item.unit_value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                    </p>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <p >{{ item.summary }}</p>

                  </td>

                </template>


                <template #operation="{item,index}">
                  <td >
                    <CButton
                        color="primary"
                        variant="outline"
                        square
                        class="m-1"
                        :title="$t('buttons.edit')"
                        size="sm"
                        @click="edit_item(index)"
                    >
                      <CIcon name="cil-pencil"/>
                    </CButton>
                    <CButton
                        color="danger"
                        variant="outline"
                        class="m-1"
                        v-if="status_product_form == -1"

                        square
                        size="sm"
                        :title="$t('buttons.delete')"
                        @click="delete_item_dialog(item)"
                    >
                      <CIcon name="cil-trash"/>
                    </CButton>
                  </td>
                </template>


              </CDataTable>
              <CRow v-if="1==0">
                <CCol col="4"></CCol>
                <CCol col="4"></CCol>
                <CCol col="4">
                  <CDataTable
                      :items="document_result_price"
                      :fields="fields_total_price"
                      striped
                      border
                      :items-per-page="200"
                      hover
                      pagination
                  >
                    <template #resultTitle="{item}">

                      <td>
                        <p >{{ item.resultTitle }}</p>

                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td>
                        <p >{{ get_currency(item.resultPrice) }}</p>

                      </td>

                    </template>

                  </CDataTable>

                </CCol>
              </CRow>
              <CRow>

              </CRow>
            </CCardBody>

          </CCard>

      </CCol>
    </CRow>
    <CRow>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Vue from "vue";
import moment from 'moment-jalaali'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

var product_items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },

  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_Weight: localStorage.getItem('weight'),

      document_result_price: [],
      date: '',
      product_items: product_items.map((item, row_id) => {
        return {...item, row_id}
      }),
      selected_priority:1,
      priority_items:[],
      product_fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'name', label: this.$t('tables.name'), _style: 'width:10%'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%;'},
        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%;'},
        // {key: 'document_person_name', label: "تامین کننده", _style: 'width:10%;'},
        // {key: 'offPrice', label: this.$t('tables.off'), _style: 'width:10%;'},
        // {key: 'taxPrice', label: this.$t('tables.tax'), _style: 'width:10%;'},
        // {key: 'totalPayPrice', label: this.$t('tables.totalPrice'), _style: 'width:10%;'},
        {key: 'summary',label: this.$t('tables.summary'), _style: 'width:10%;'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],
      selectTypes: [
        {
          value: 1,
          label: this.$t('sidebars.administrative')
        },
        {
          value: 2,
          label: this.$t('supplyInventory')
        }, {
          value: 3,
          label: this.$t('consumed')
        },
      ],
      selectedType: 0,
      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),

      department_items: [],
      selected_department: null,

      document_person: 0,
      document_person_name: "",
      document_person_method_name: "",
      document_person_remain_amount: "",
      document_summary: '',


      product_name: '',
      product_existance: '',
      product_count: '',
      product_unit: '',
      product_unit_name: '',
      product_weight: '',
      product_summary: '',
      product_price: 0,
      product_off: '',
      product_tax: '',
      product_off_is_percent: '',

      text_input_searcher: null,

      total_price: 0,
      total_weight: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      unit_items: [],
      unit_items_filtered: [],
      selected_place: 0,
      places_items: [],

      selected_product: null,
      status_product_form: -1,
      status_form: 0,
      master_id: 0,
      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,
        }
      },

      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  computed: {

    data_units() {
      var units_data = [];
      this.unit_items_filtered.forEach((val) => {
        var obj = {label: val.unitName, value: val.id}
        units_data.push(obj);
      });
      return units_data;
    },

    get_document_type_label() {
      if (this.selectedType == 1) {
        return this.$t('components.buyDocument');
      }
      if (this.selectedType == 3) {
        return this.$t('components.sellDocument');

      }
      if (this.selectedType == 5) {
        return this.$t('components.firstDocument');
      }

    }
  },
  mounted() {
    this.get_departments();
    this.get_sys();

    // console.log(document.getElementById("product_seeker").children[0].children[0].children[1].children[0]);
    this.selectedType = this.$route.params.type_id
    this.$root.root_validate_errors = [];
    this.date = this.get_today();
    // this.get_product_units();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_product_form = -1;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

      } else {
        this.status_form = 0;
      }
    });

    if (this.$route.params.user_id != null) {
      this.status_form = this.$route.params.user_id;
      // this.get_user_data();
    }

    if (this.$route.params.edit_doc_id != null) {
      this.status_form = this.$route.params.edit_doc_id;
      this.get_document_master();
      this.get_document_details();
    }
  },
  watch: {

    'selectedType': function () {
      if (this.selectedType == 1) {
        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeQty = 1;
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeQty = -1;

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeQty = 1;

      }
    },
    '$route.params.type_id': function () {
      location.reload()
    },


    'product_items': function () {
      this.total_price = 0;
      var total_off = 0;
      var total_tax = 0;
      var total_pay_price = 0;
      this.total_weight = 0;
      this.document_result_price = [];
      this.product_items.forEach((val) => {
        total_off += this.calculate_off_price(val);
        total_tax += this.calculate_tax_price(val);
        total_pay_price += this.calculate_total_price(val);
        this.total_price += this.calculate_total_pay_price(val);
        this.total_weight += (val.count * val.weight * val.unit_value);

      });

      // this.total_price = this.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.total_weight = this.total_weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      var obj = {resultTitle: this.$t('totalPrice'), resultPrice: total_pay_price};
      this.document_result_price.push(obj)
      obj = {resultTitle: "مبلغ تخفیف", resultPrice: total_off};
      this.document_result_price.push(obj)
      obj = {resultTitle: "مبلغ بعد تخفیف", resultPrice: total_pay_price - total_off};
      this.document_result_price.push(obj)
      obj = {resultTitle: "مبلغ مالیات", resultPrice: total_tax};
      this.document_result_price.push(obj)
      obj = {resultTitle: "مبلغ قابل پرداخت", resultPrice: this.total_price};
      this.document_result_price.push(obj)


      obj = {resultTitle: "مانده از قبل", resultPrice: this.document_person_remain_amount};
      this.document_result_price.push(obj)
  obj = {resultTitle: "مبلغ نهایی", resultPrice: parseInt(this.document_person_remain_amount)+parseInt(this.total_price)};
      this.document_result_price.push(obj)

    },

  },
  methods: {

    select_product(node,instance){
      console.log("node is",node)
      this.product_name = node.productName;
      this.product_existance = node.existence;
      this.product_price = node.salePrice;
      if (this.product_price==null){
        this.product_price = 0;
      }

      this.product_weight = node.weight;
      this.product_off = node.takhfif;
      this.product_tax = node.vat;
      this.product_off_is_percent = node.isPercent;
      this.product_unit = node.productUnitId;
      this.product_unit_name = node.productUnitName;
      this.product_unit_value = node.value;

    },
    select_supplier(node,instance){
      console.log("node is",node)
      this.document_person_name = node.userName;
      this.document_person = node.userId;


    },
    get_departments() {
      var self = this;

      const formData = new FormData();

      formData.append('BranchId', localStorage.getItem("branchId"));


      axios.post('BranchDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.department_items = []
          var obj = {
            "label": self.$t('selectDepartmanUnit'),
            value: 0,

          }
          self.department_items.push(obj);

          self.department_all_job_titles = response.data.data;
          var departments = response.data.data.filter(x=>x.branchId == localStorage.getItem("branchId"));
          // departments = departments.filter(item => item.recType == 0);

          departments.forEach((val) => {
            if (val.parentId != 0) {

            var obj = {
              label: val.mainDepartemanTitle,
              parentId: val.parentId,
              value: val.mainDepartemanId,
              recType: val.recType,
              image_url: '/img/avatars/custom.png',

              // "selected":true,
              children: self.get_department_childrens(val.id, response.data.data),
              // mate: self.get_mates(val.id, response.data.data)
            }
            self.department_items.push(obj);
            }

          });
          self.selected_department = self.department_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.selectTypes = [];
        self.priority_items = [];
        // self.favourite_options = [];

        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 18) {
            self.priority_items.push(obj);
          }
          if (val.titleType == 19) {
            self.selectTypes.push(obj);
          }
        });

        self.selected_priority = self.priority_items[0].value
        self.selectedType = self.selectTypes[0].value

        // self.selected_specification = self.specification_options[0].value
        // self.selected_favourite = self.favourite_options[0].value


      })
              .catch(function (error) {

                console.log(error);
              });

    },

    get_department_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_department_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);

          // val2.inserted = true;

        }

      });
      if (array.length) {
        return array;

      } else {
        return null;

      }

    },

    calculate_total_price(item) {
      return item.price * item.count * item.unit_value;
    },
    calculate_off_price(item) {
      var  off =0;
      if (item.product_off_is_percent == true) {
        off= parseInt((item.product_off * this.calculate_total_price(item)) / 100);
      } else {
        off= item.product_off * item.count * item.unit_value;
      }
      if(off){
        return off;
      }else{
        return  0;
      }
    },
    calculate_tax_price(item) {
      // return parseInt(item.product_tax * item.count * item.unit_value);
      var tax = (item.product_tax * this.calculate_total_price(item)) / 100;
      if(!tax){
        return 0;
      }else{
        return tax;

      }
    },
    calculate_total_pay_price(item) {
      return this.calculate_total_price(item) - this.calculate_off_price(item) + this.calculate_tax_price(item)
    },

    validateForm: function () {
      this.$root.root_validate_errors = [];


      if (this.selectedType != 0 && this.selected_department != 0 && this.selected_priority != 0 && this.product_items.length > 0) {
        return true;

      }

      if (this.selectedType == 0) {
        this.$root.root_validate_errors.push(this.$t('selectOrderType'));
      }
      if (this.selected_department == 0) {
        this.$root.root_validate_errors.push(this.$t('selectUnit'));
      }
      if (this.selected_priority == null) {
        this.$root.root_validate_errors.push(this.$t('selectStatus'));
      }
      if (this.product_items.length == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectProducts'));
      }

      return false;
      // e.preventDefault();
    },
    validateProduct: function () {
      this.$root.root_validate_errors = [];
      var duplicate_product = false;
      this.product_items.forEach((val) => {
        if (val.product_id == this.selected_product && this.status_product_form == -1) {
          this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
          duplicate_product = true;

        }
        // val.row_id = row_index;
        // row_index += 1;
      });

      if (this.product_name != '' && this.product_count != ''  && this.product_count != 0 && !duplicate_product) {
        return true;


      }

      if (this.product_name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.product_count == '' || this.product_count == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
      }

      // if (this.document_person_name == "") {
      //   this.$root.root_validate_errors.push("تامین کننده را انتخاب کنید");
      // }


      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    add_product_to_document() {
      if (this.validateProduct()) {

        var product_new_item = [];
        this.unit_items.forEach((val) => {
          if (val.id == this.product_unit) {
            product_new_item.unit_value = val.value;
            product_new_item.unit_value_name = val.unitName;
          }


        });

        product_new_item.document_person_name = this.document_person_name;
        product_new_item.document_person = this.document_person;
        product_new_item.name = this.product_name;

        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;
        console.log('product is ', product_new_item)
        this.product_items.push(product_new_item);
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.document_person_name = "";
        this.document_person = null;
        this.product_summary = '';
        this.product_price = 0;
        this.selected_product = null;

        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        if (this.status_form != 0) {
          this.add_one_factor_product(this.product_items.length - 1);
        }
        // this.text_input_searcher = document.getElementById("product_seeker").children[0].children[0].children[1].children[0]
        //
        // this.text_input_searcher.focus();
      }
    },
    update_product_to_document() {
      if (this.validateProduct()) {
        // this.status_product_form = -1;
        var product_new_item = [];
        this.unit_items.forEach((val) => {
          if (val.id == this.product_unit) {
            product_new_item.unit_value = val.value;
            product_new_item.unit_value_name = val.unitName;

          }
          // val.row_id = row_index;
          // row_index += 1;

        });
        if (this.status_product_form != -1) {
          product_new_item.detail_id = this.product_items[this.status_product_form].detail_id;

        }
        product_new_item.name = this.product_name;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;
        this.product_items.splice(this.status_product_form, 1, product_new_item);
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = 0;
        this.selected_product = null;
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        if (this.status_form != 0) {
          this.edit_factor_product(this.status_product_form)

        } else {
          this.status_product_form = -1;

        }
      }
    },
    edit_item(index) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      var product_new_item = this.product_items[index];
      this.product_name = product_new_item.name;
      this.product_unit = product_new_item.unit;
      this.product_count = product_new_item.count;
      this.product_weight = product_new_item.weight;
      this.product_price = product_new_item.price;
      this.product_summary = product_new_item.summary;
      this.product_off = product_new_item.product_off;
      this.product_tax = product_new_item.product_tax;
      this.product_off_is_percent = product_new_item.product_off_is_percent;
      this.selected_product = product_new_item.product_id;
      // this.product_items.push(product_new_item);
      this.status_product_form = index;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      if (this.status_form != 0) {
        this.$router.push({path: '/dashboard/products/list'})
      } else {
        this.status_form = 0;
        this.name = '';
        this.color = '';
        this.description = '';
        this.previewImage = '';
        this.weight = '';
        this.selected_unit = '0';
        this.selected_brand = '0';
        this.selected_category = '0';
        this.barcode = '';
      }

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    insert_data_factor() {
      if (!this.validateForm()) {
        return true;
      }

      var self = this;

   var master = {MasterCode:"",DeliveryTime:this.date,
     UserUnitId:this.selected_department,
     RequestFor:this.selectedType,
     PriorityId:this.selected_priority,
      };

      var sending_products = [];
      self.product_items.forEach((val) => {

        var pro_obj = {
          MasterId:this.master_id,
          ProductId: val.product_id,  Qty: val.count,
          Summary:val.summary,
          Price: val.price, SupplierId: val.document_person
        };
        if(pro_obj.SupplierId==null){
          pro_obj.SupplierId=0;
        }
        sending_products.push(pro_obj);
      });
      var final_sending = {'master':master ,'details': sending_products};

      const formData = new FormData();
      let url;

      if (this.status_form == 0) {
        url = "AddPurchaseRequest";
      } else {
        url = "EditPurchaseRequest";
        formData.append('Id', this.status_form)

      }

      formData.append('input', JSON.stringify(final_sending));

      axios.post(url, formData, {}).then((res) => {
        //


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          bus.$emit("update_orders", "");

          // self.master_id = res.data.data.id;
          self.product_items= [];
          // self.insert_factor_products();
            this.selected_department = 0,
            this.selectedType= 1;
            this.selected_priority = 1;

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.master_id = self.status_form;
          // self.insert_factor_products();

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    insert_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddOrderDetail";
      } else {
        url = "EditOrderDetail";
        formData.append('Id', this.status_form)

      }
      // AddFactorDetail
      // GetDetailRecById
      // EditFactorDetail
      // DeleteFactorDetail
      //     MasterId
      //     PlaceId
      //     ProductId
      //     ProductUnitId
      //     Qty
      //     Price
      //     DocDesc
      var sending_products = [];
      self.product_items.forEach((val) => {

        var pro_obj = {
          MasterId: self.master_id, PlaceId: self.selected_place,
          ProductId: val.product_id, ProductUnitId: val.unit, Qty: val.count * self.selectedTypeQty,
          Price: val.price, Summary: val.summary
        };
        sending_products.push(pro_obj);
      });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {
        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_one_factor_product(index) {

      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorDetail";
      // } else {
      //     url = "EditFactorDetail";
      //     formData.append('Id', this.status_form)
      //
      // }
      // AddFactorDetail
      // GetDetailRecById
      // EditFactorDetail
      // DeleteFactorDetail
      //     MasterId
      //     PlaceId
      //     ProductId
      //     ProductUnitId
      //     Qty
      //     Price
      //     DocDesc
      var sending_products = [];
      // self.product_items.forEach((val) => {

      var pro_obj = {
        MasterId: self.status_form,
        PlaceId: self.selected_place,
        ProductId: self.product_items[index].product_id,
        ProductUnitId: self.product_items[index].unit,
        Qty: self.product_items[index].count * self.selectedTypeQty,
        Price: self.product_items[index].price,
        Summary: self.product_items[index].summary
      };
      sending_products.push(pro_obj);
      // });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_factor_product(index) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "EditFactorDetail";

      var sending_products = [];
      // self.product_items.forEach((val) => {

      var pro_obj = {
        MasterId: self.master_id,
        PlaceId: self.selected_place,
        ProductId: self.product_items[index].product_id,
        ProductUnitId: self.product_items[index].unit,
        Qty: self.product_items[index].count * self.selectedTypeQty,
        Price: self.product_items[index].price,
        ProductDesc: self.product_items[index].summary
      };
      sending_products.push(pro_obj);
      // });
      // var final_sending = {'details': sending_products};
      // formData.append('model', JSON.stringify(final_sending));
      formData.append('MasterId', self.status_form);
      formData.append('Id', this.product_items[index].detail_id);
      formData.append('PlaceId', this.selected_place);
      formData.append('ProductId', this.product_items[index].product_id);
      formData.append('ProductUnitId', this.product_items[index].unit);
      formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      formData.append('Price', this.product_items[index].price);
      formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;
          self.status_product_form = -1;
          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_product_form = item.row_id;

    },
    delete_item() {

      this.product_items.splice(this.status_product_form, 1);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });
      this.product_name = "";
      this.product_unit = "";
      this.product_count = "";
      this.product_summary = '';
      this.product_price = 0;
      this.selected_product = null;

        this.status_product_form = -1;


    },
    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person_name = content_data.data.partyName;
          self.document_person = content_data.data.partyId;
          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.placeId;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {


          content_data.data.forEach((val) => {
            self.add_edit_factor_product_to_document(val);
          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    add_edit_factor_product_to_document(item) {
      // ,,"productUnitId":1,"productUnitName":"کارتن 12 تایی","value":12,"qty":1,"price":"11960","docDesc":""
      var product_new_item = [];

      this.unit_items.forEach((val) => {
        if (val.id == item.productUnitId) {
          product_new_item.unit_value = val.value;
        }
        // val.row_id = row_index;
        // row_index += 1;

      });
      product_new_item.detail_id = item.detailId;
      product_new_item.name = item.productName;
      product_new_item.unit = item.productUnitId;
      if (item.qty < 0) {
        item.qty = item.qty * -1;
      }
      product_new_item.count = item.qty;
      product_new_item.price = item.price;
      product_new_item.summary = item.docDesc;
      product_new_item.product_id = item.productId;
      this.product_items.push(product_new_item);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });

    }
  }
}

</script>
